var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPieChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20_1012)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.80002 2.80002V11.2H17.2C17.2 15.8392 13.4392 19.6 8.80002 19.6C4.16083 19.6 0.400024 15.8392 0.400024 11.2C0.400024 6.56083 4.16083 2.80002 8.80002 2.80002ZM7.59814 4.00002C4.16918 4.57529 1.60002 7.55747 1.60002 11.1499C1.60002 15.154 4.84601 18.4 8.85015 18.4C9.14767 18.4 9.44102 18.3824 9.72915 18.3481L7.59814 12.4V4.00002ZM16 12.4H8.90922L10.9199 18.1046C13.5401 17.3362 15.5399 15.1425 16 12.4ZM10 0.400024C15.302 0.400024 19.6 4.69809 19.6 10H10V0.400024ZM11.2 1.60002V8.80002H18.4C17.8738 5.12119 14.8789 2.12624 11.2 1.60002Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20_1012"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieChart);
export default __webpack_public_path__ + "static/media/pie-chart.102a9f69.svg";
export { ForwardRef as ReactComponent };